export class InputSelection {
    constructor(public start: number, public end: number) {
    }
}
